import React, { useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    Grid,
    List,
    ListItem,
    Alert,
    CircularProgress
} from "@mui/material";
import Layout from '../../components/layout/Layout';
import { postData } from '../../services/apiService';

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const validations = {
        upperCase: /[A-Z]/.test(formData.newPassword),
        number: /\d/.test(formData.newPassword),
        length: formData.newPassword.length >= 8,
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear messages when user starts typing
        if (error) setError("");
        if (success) setSuccess("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess("");

        // Validations
        if (formData.newPassword !== formData.confirmPassword) {
            setError("Passwords do not match!");
            setLoading(false);
            return;
        }

        if (!validations.upperCase || !validations.number || !validations.length) {
            setError("Password does not meet all requirements.");
            setLoading(false);
            return;
        }

        try {
            // Prepare data for API
            const payload = {
                currentPassword: formData.currentPassword,
                newPassword: formData.newPassword,
                confirmPassword: formData.confirmPassword
            };

            // Call API
            const response = await postData('/change-password', payload);

            // Handle success
            setSuccess("Password changed successfully!");
            setFormData({
                currentPassword: "",
                newPassword: "",
                confirmPassword: ""
            });
        } catch (error) {
            console.error('Failed to change password', error);
            setError(error.response?.data?.message || "Failed to change password. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            {/* <Box className="p-6 bg-gray-100 min-h-screen"> */}
                <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: "100vh", backgroundColor: "#f2f4f8" }} >
                    <Paper elevation={3} sx={{ p: 4, width: "400px", borderRadius: 3, backgroundColor: "white", }} component="form" onSubmit={handleSubmit} >
                        <Typography variant="h5" gutterBottom fontWeight="bold">
                            Change your password
                        </Typography>

                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}

                        {success && (
                            <Alert severity="success" sx={{ mb: 2 }}>
                                {success}
                            </Alert>
                        )}

                        <TextField type="password" label="Current Password" name="currentPassword"
                            fullWidth margin="normal" value={formData.currentPassword} onChange={handleChange} required
                        />

                        <TextField type="password" label="New Password" name="newPassword" fullWidth
                            margin="normal" value={formData.newPassword} onChange={handleChange} required
                        />

                        <TextField type="password" label="Confirm New Password" name="confirmPassword"
                            fullWidth margin="normal" value={formData.confirmPassword} onChange={handleChange} required
                        />

                        <Button type="submit" fullWidth variant="contained" disabled={loading}
                            sx={{
                                mt: 2, backgroundColor: "#5c1dd9", "&:hover": { backgroundColor: "#4a12b5" },
                            }}
                        >
                            {loading ? <CircularProgress size={24} /> : "Change my password"}
                        </Button>

                        <Box mt={3}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Password must contain:
                            </Typography>
                            <List sx={{ fontSize: "14px" }}>
                                <ListItem
                                    sx={{
                                        color: validations.upperCase ? "green" : "black",
                                        textDecoration: validations.upperCase ? "line-through" : "none",
                                    }}
                                >
                                    At least 1 upper case letter (A-Z)
                                </ListItem>
                                <ListItem
                                    sx={{
                                        color: validations.number ? "green" : "black",
                                        textDecoration: validations.number ? "line-through" : "none",
                                    }}
                                >
                                    At least 1 number (0-9)
                                </ListItem>
                                <ListItem
                                    sx={{
                                        color: validations.length ? "green" : "black",
                                        textDecoration: validations.length ? "line-through" : "none",
                                    }}
                                >
                                    At least 8 characters
                                </ListItem>
                            </List>
                        </Box>
                    </Paper>
                </Grid>
            {/* </Box> */}
        </Layout>
    );
};

export default ChangePassword;